import type { BlogPost } from '../types'

export const YA_ESTAMOS_EN_MARCHA: BlogPost = {
  slug: 'ya-estamos-en-marcha',
  lang: 'es',
  topicId: 'wir-sind-live',
  title: 'Roofora ya está en marcha',
  metaDescription:
    'Roofora ya está activo: el mercado donde las empresas instaladoras compiten por su proyecto ' +
    'solar - sin acoso telefónico, sin llamadas comerciales.',
  keywords: [
    'Roofora lanzamiento',
    'comparar presupuestos solares sin llamadas',
    'mercado fotovoltaico nuevo',
    'presupuestos solares sin llamadas comerciales',
    'pedir presupuestos PV sin acoso telefónico',
  ],
  publishedAt: '2026-07-11',
  excerpt:
    'La historia es sencilla: yo mismo pedí una vez un presupuesto para una instalación solar y ' +
    'acabé recibiendo llamadas de prácticamente todas las empresas. Me molestó tanto que pensé: ' +
    'esto se puede hacer mejor. Así que lo construí yo mismo - y ahora Roofora está en marcha.',
  sections: [
    {
      type: 'paragraph',
      text:
        'La historia es sencilla: yo mismo pedí una vez un presupuesto para una instalación solar y ' +
        'acabé recibiendo llamadas y correos de prácticamente todas las empresas - miles de ' +
        'llamadas, presupuestos inflados, ventas agresivas sin fin. Me molestó tanto que pensé: ' +
        'esto se puede hacer mejor. Así que lo construí yo mismo.',
    },
    {
      type: 'paragraph',
      text:
        'El resultado es Roofora - y desde hoy la plataforma está activa. Se acabó el concepto, se ' +
        'acabaron los anuncios de "beta próximamente" - ya puede enviar una solicitud y recibir ' +
        'presupuestos reales de empresas instaladoras, sin tener que apagar después el teléfono.',
    },
    {
      type: 'heading',
      text: 'Qué falla en los portales comparadores clásicos',
    },
    {
      type: 'paragraph',
      text:
        'Muchos conocen el patrón: se envía una solicitud, se indica el teléfono y el correo ' +
        'electrónico - y ese mismo contacto se vende de inmediato a varias empresas a la vez. El ' +
        'resultado es una avalancha de llamadas hasta el punto de no saber ya qué llamada ' +
        'corresponde a qué presupuesto. Ese problema de fondo es justo lo que en Roofora queríamos ' +
        'no solo mitigar, sino evitar de forma estructural.',
    },
    {
      type: 'heading',
      text: 'Cómo funciona Roofora en su lugar',
    },
    {
      type: 'list',
      items: [
        'Envíe su solicitud: fotos del tejado, foto del cuadro eléctrico, orientación del tejado y consumo anual - el tamaño de instalación adecuado se calcula automáticamente',
        'Publicación anónima: las empresas instaladoras ven su solicitud, pero no sus datos de contacto',
        'Las empresas presentan, de forma independiente, presupuestos sin compromiso a precio fijo - sin que usted tenga que hacer nada',
        'Usted compara con calma los presupuestos ordenados por precio',
        'El contacto solo se produce cuando usted da su consentimiento activo a una única empresa concreta - sin autorización colectiva para todas',
        'Para la cuenta solo necesita un nombre de usuario y una contraseña - ni el correo ni el teléfono son necesarios para registrarse',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Además, hay una calculadora solar gratuita y sin registro con la que en pocos minutos ' +
        'obtiene una primera estimación del tamaño de instalación y la producción de su tejado - ' +
        'incluida la exportación del análisis en PDF.',
    },
    {
      type: 'heading',
      text: 'Para empresas instaladoras',
    },
    {
      type: 'paragraph',
      text:
        'Los instaladores solares y las empresas de electricidad ven solicitudes anónimas de su ' +
        'región - incluidos los datos del tejado, el consumo y el presupuesto más bajo actual, pero ' +
        'sin datos de contacto. Presentar un presupuesto es gratuito y sin compromiso. Si una ' +
        'empresa quiere además contactar con el cliente, envía una solicitud de contacto también ' +
        'gratuita y espera la autorización individual de ese cliente en concreto.',
    },
    {
      type: 'heading',
      text: 'Para ser honestos: por ahora un proyecto personal, completamente gratuito',
    },
    {
      type: 'paragraph',
      text:
        'Roofora es actualmente un proyecto personal en fase beta - totalmente gratuito tanto para ' +
        'clientes como para empresas instaladoras. Sin modelo de pago oculto, sin tarjeta de ' +
        'crédito, sin trampas de suscripción. Si esto cambiara en el futuro, lo anunciaremos con ' +
        'total transparencia - hasta entonces, probarlo no cuesta nada.',
    },
    {
      type: 'paragraph',
      text:
        'Si está planeando una instalación solar y no le apetece el acoso telefónico, pruebe ' +
        'Roofora - la solicitud se completa en pocos minutos, y usted decide en todo momento quién ' +
        'puede contactarle.',
    },
  ],
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: '¿Cuánto cuesta una instalación fotovoltaica?', href: '/coste-instalacion-fotovoltaica' },
  ],
}
